import { i18n } from '@/i18n';
import { IMasterItem, IOutputDataItem } from '../domains/entities/InventoryTemplate';

/**
 * マスタ項目のキー定義
 * バックエンドのキー名と統一
 */
export const MASTER_ITEM_KEYS = [
  'warehouseNumber',
  'warehouse',
  'supplierNumber',
  'supplierName',
  'businessNumber',
  'businessName',
  'package',
  'unit',
  'customerNumber',
  'customerName',
  'salesDestinationNumber',
  'salesDestinationName',
  'forecastForReceiptName',
  'manufacturer',
  'endUser',
  'purchaseUnitPrice',
  'salesUnitPrice',
  'leadTime',
  'standardInventoryIndexMin',
  'standardInventoryIndexMax',
  'group',
  'orderPackage',
  'moq',
  'userUniqueNumber',
  'aggregateBusinessResponsibleUsers',
  'baseBusinessResponsibleUsers',
  'createAt',
  'updateAt',
  'memo',
] as const;

/**
 * 出力データ項目のキー定義
 */
export const OUTPUT_DATA_ITEM_KEYS = [
  'currentInventory',
  'monthEndInventory',
  'salesPerformance',
  'arrivalPerformance',
  'inventoryTurnoverRate',
  'order',
  'customerForecastLatest',
  'supplierForecastLatest',
  'customerForecastN1',
  'customerForecastN2',
  'customerForecastN3',
  'customerForecastN4',
  'customerForecastN5',
  'customerForecastN6',
  'customerForecastN7',
  'customerForecastN8',
  'customerForecastN9',
  'customerForecastN10',
  'customerForecastN11',
  'customerForecastN12',
  'supplierForecastN1',
  'supplierForecastN2',
  'supplierForecastN3',
  'supplierForecastN4',
  'supplierForecastN5',
  'supplierForecastN6',
  'supplierForecastN7',
  'supplierForecastN8',
  'supplierForecastN9',
  'supplierForecastN10',
  'supplierForecastN11',
  'supplierForecastN12',
] as const;

/**
 * マスタ項目の初期値を取得
 */
export const getInitialMasterItems = (): IMasterItem[] => {
  return MASTER_ITEM_KEYS.map((key) => ({
    key,
    label: i18n.t(key),
    checked: false,
  }));
};

/**
 * 出力データ項目の初期値を取得
 */
export const getInitialOutputDataItems = (): IOutputDataItem[] => {
  return OUTPUT_DATA_ITEM_KEYS.map((key) => ({
    key,
    label: i18n.t(key),
    checked: false,
  }));
};

/**
 * プレビューに表示する最大ヘッダー数
 */
export const MAX_PREVIEW_HEADERS = 12;

/**
 * 月に依存しない単一フィールドとして表示する出力データ項目のキー
 * これらの項目は年月ごとに繰り返し表示されず、1つのカラムとして表示される
 */
export const SINGLE_FIELD_OUTPUT_KEYS = ['currentInventory'] as const;

/**
 * 単一フィールド項目かどうかを判定
 * @param key - 出力データ項目のキー
 * @returns 単一フィールド項目の場合はtrue
 */
export const isSingleFieldOutputKey = (key: string | undefined): boolean => {
  if (!key) return false;
  return SINGLE_FIELD_OUTPUT_KEYS.includes(key as (typeof SINGLE_FIELD_OUTPUT_KEYS)[number]);
};
